// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
// Components
import NoteInput from '../../../Notes/NoteInput';
import OMLabelNew from '../../OMLabelNew/OMLabelNew';
import OMLabelTop from '../../OMLabelTop/OMLabelTop';
import CellInfoIconsBlock from '../components/CellInfoIconsBlock/CellInfoIconsBlock';
import CellPhotoBlock from '../components/CellPhotoBlock/CellPhotoBlock';
// Helpers
import parkingConverter from '../../../../utils/parkingConverter';
import isDescendant from '../../../../utils/isDescendant';
import propertyNoteIcon from '../../../../../static/icons/note.svg';
import buildVideoLinks from '../../../../utils/buildVideoLinks';
import { isVideoPosterReady, resolveMediaStatusBadge } from '../../../../utils/normalizeMediaStatus';
import VideoStatusBadge from '../../../VideoStatusBadge/VideoStatusBadge';
import ImageStatusBadge from '../../../ImageStatusBadge/ImageStatusBadge';
// Styles
import * as styles from './OMBasePropertyCell.scss';


class OMBasePropertyCell extends Component {
  state = {
    showNote: false
  };

  componentWillReceiveProps({ propertyNote }) {
    if (!propertyNote && this.props.propertyNote !== propertyNote) {
      this.setState({ showNote: false });
    }
  }

  shouldComponentUpdate(newProps, newState) {
    const isIdChanged = (newProps.id !== this.props.id);
    const isLocaleChanged = (newProps.locale !== this.props.locale);
    const isPriceChanged = (newProps.price !== this.props.price);
    const isFavoriteStateChanged = (newProps.isFavorite !== this.props.isFavorite);
    const isShowNoteChanged = (newState.showNote !== this.state.showNote);
    const isPropertyNoteChanged = (newProps.propertyNote !== this.props.propertyNote);
    const isActive = (newProps.active !== this.props.active);
    const isShowPromotion = (newProps.showPromotion !== this.props.showPromotion);

    return (
      isIdChanged ||
      isLocaleChanged ||
      isFavoriteStateChanged ||
      isShowNoteChanged ||
      isPropertyNoteChanged ||
      isPriceChanged ||
      isActive ||
      isShowPromotion
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.showNote && this.state.showNote) {
      document.body.addEventListener('click', this.hideNote, true);
    }

    if (prevState.showNote && !this.state.showNote) {
      document.body.removeEventListener('click', this.hideNote, true);
    }
  }

  hideNote = (evt) => {
    const isNoteIcon = this.noteWrapper && isDescendant(this.noteWrapper, evt.target);

    if (!isNoteIcon) {
      this.setState({ showNote: false });
    }
  };

  toggleNote = () => this.setState({ showNote: !this.state.showNote });

  renderLabelTop = () => {
    const { isRocketPromotedProperty, isTopPromotedProperty, showPromotion = true } = this.props;

    return !isRocketPromotedProperty && isTopPromotedProperty && showPromotion && (
      <div className={styles.labelNew}>
        <OMLabelTop
          label="TOP"
          isMobile={this.props.isMobile}
        />
      </div>
    );
  }

  renderNote = () => ((!!this.props.propertyNote) && (
    <div className={styles.noteIconWrapper} id={`note_for_${this.props.id}`} ref={(ref) => { this.noteWrapper = ref; }}>
      <img
        src={propertyNoteIcon}
        alt=""
        className={styles.noteIcon}
        onClick={this.toggleNote}
      />

      {(this.state.showNote) && (
        <div className={styles.noteTooltip}>
          <NoteInput
            value={this.props.propertyNote}
            addNote={this.props.addPropertyNote}
          />
        </div>
      )}
    </div>
  ));

  renderLabelNew = () => {
    const { isRocketPromotedProperty, isTopPromotedProperty, showPromotion } = this.props;
    const shouldShowPromotion = (isRocketPromotedProperty || isTopPromotedProperty) && showPromotion;

    return this.props.isNewProperty && !shouldShowPromotion && (
      <div className={styles.labelNew}>
        <OMLabelNew
          label={this.props.newPropertyLabel.toString()}
          title={this.props.newPropertyTitle.toString()}
          isMobile={this.props.isMobile}
        />
      </div>
    );
  }

  renderRocket = () => {
    const { isRocketPromotedProperty, showPromotion } = this.props;
    return isRocketPromotedProperty && showPromotion && (
      <div className={styles.labelNew}>
        <i className="icon icon-top-promotion-active">
          <span className="path1" />
          <span className="path2" />
        </i>
        <p>+</p>
        <i className="icon icon-rocket-active" />
      </div>
    );
  };

  renderVRIcon = (hasVRLink) => hasVRLink && (
    <span className={cx(styles.labelVR, 'icon', 'icon-vr-view')}>
    <span className="path1" />
    <span className="path2" />
    <span className="path3" />
    <span className="path4" />
    <span className="path5" />
  </span>
  );

  render() {
    const parkingSpots = parkingConverter(this.props.parkingSpots);
    const groundFloor = +this.props.floor === 0;
    const {
      translate,
      locale,
      isRtl,
      photo,
      price,
      currency,
      classNameProperty,
      showManagePropertiesPack,
      onOpenDetails,
      neighborhood,
      city,
      address,
      countryName,
      videos = []
    } = this.props;

    const videoPoster = !photo && !!videos.length && isVideoPosterReady(videos[0])
      ? buildVideoLinks(videos[0]).thumbnail
      : undefined;
    const mediaStatusBadge = resolveMediaStatusBadge({ images: this.props.images, videos });

    return (
      <div onClick={onOpenDetails} className={cx(styles.propertyRow, classNameProperty)}>
        {!showManagePropertiesPack && <div className={styles.iconsWrapper}>
          {this.renderNote()}
          {this.renderVRIcon(this.props.hasVRLink)}
          {this.renderLabelNew()}
          {this.renderLabelTop()}
          {this.renderRocket()}
        </div>}
        <CellPhotoBlock
          classNameProperty={classNameProperty}
          active={this.props.active}
          locale={locale}
          isRtl={isRtl}
          images={this.props.images}
          isFavorite={this.props.isFavorite}
          // hasVRLink={this.props.hasVRLink}
          onSlideChange={this.props.onSlideChange}
          photo={photo}
          imageModifier={this.props.imageModifier}
          price={price}
          currency={currency}
          toggleFavorite={this.props.toggleFavorite}
          searchOption={this.props.searchOption}
          translate={translate}
          showManagePropertiesPack={this.props.showManagePropertiesPack}
          withoutPagination
          videoPoster={videoPoster}
          videoStatusBadge={
            mediaStatusBadge?.type === 'video'
              ? <VideoStatusBadge status={mediaStatusBadge.item.status} error={mediaStatusBadge.item.error} compact />
              : undefined
          }
          imageStatusBadge={
            mediaStatusBadge?.type === 'image'
              ? <ImageStatusBadge status={mediaStatusBadge.item.status} error={mediaStatusBadge.item.error} compact />
              : undefined
          }
        />

        <div className={cx(styles.propertyDescription, classNameProperty)}>
          <div className={styles.infoBlock}>
            <div className={styles.addressWrap}>
              <div className={styles.propertyType}>
                {this.props.propertyType}
              </div>

              <div property="address" className={styles.propertyAddress}>
                <div>{address}</div>
                <div className={styles.neighborhood}>
                  {neighborhood && (neighborhood !== city) && <div>{neighborhood}, &nbsp;</div>}
                  <div>{city}</div>
                </div>
                <div>{countryName && countryName}</div>
              </div>
            </div>
            <CellInfoIconsBlock
              className={classNameProperty}
              locale={locale}
              area={this.props.area}
              floor={(groundFloor) ? this.props.groundFloorTitle.toString() : this.props.floor}
              floorIconTitle={this.props.floorIconTitle}
              parkingIconTitle={this.props.parkingIconTitle}
              parkingSpots={parkingSpots}
              rooms={this.props.rooms}
              roomsIconTitle={this.props.roomsIconTitle}
              squareIconTitle={this.props.squareIconTitle}
            />
          </div>
          {this.props.showManagePropertiesPack &&
            <button
              className={styles.btnEdit}
              onClick={this.props.onHandlerEdit}
            >
              <i className="icon icon-edit" >
                <i className="path1" />
                <i className="path2" />
              </i>
            </button>
          }
        </div>
      </div>
    );
  }
}

OMBasePropertyCell.propTypes = {
  locale: PropTypes.string,
  isMobile: PropTypes.bool,
  isRtl: PropTypes.bool,
  onOpenDetails: PropTypes.func,
  className: PropTypes.string,
  classNameProperty: PropTypes.string,
  id: PropTypes.string,
  propertyType: PropTypes.string,
  photo: PropTypes.string,
  price: PropTypes.number,
  address: PropTypes.string,
  rooms: PropTypes.number,
  parkingSpots: PropTypes.object,
  city: PropTypes.string,
  area: PropTypes.number,
  floor: PropTypes.number,
  isFavorite: PropTypes.bool,
  isNewProperty: PropTypes.bool,
  showManagePropertiesPack: PropTypes.bool,
  isRocketPromotedProperty: PropTypes.bool,
  hasVRLink: PropTypes.bool,
  propertyNote: PropTypes.string,
  parkingIconTitle: PropTypes.func,
  roomsIconTitle: PropTypes.func,
  floorIconTitle: PropTypes.func,
  squareIconTitle: PropTypes.func,
  groundFloorTitle: PropTypes.func,
  active: PropTypes.bool,
  newPropertyTitle: PropTypes.string,
  newPropertyLabel: PropTypes.string,
  onHandlerEdit: PropTypes.func,
  addPropertyNote: PropTypes.func,
  toggleFavorite: PropTypes.func,
  searchOption: PropTypes.string,
  translate: PropTypes.func,
  isTopPromotedProperty: PropTypes.bool,
  currency: PropTypes.string,
  images: PropTypes.object,
  neighborhood: PropTypes.string,
  countryName: PropTypes.string,
  showPromotion: PropTypes.bool,
  onSlideChange: PropTypes.func,
  videos: PropTypes.array,
  imageModifier: PropTypes.string
};

export default OMBasePropertyCell;
